import useSWRMutation from 'swr/mutation';

import config from '@/core/config/config';
import { CREATE_BOOKING } from '@/graphql/mutations/apps/createBooking';
import { customFetcher, getGqlString } from '@/utils/customFetcher';
import { swrConfig } from '@/utils/swrConfig';

const createBookingMutationFetcher = (url: string, { arg }: { arg: any }) => {
  return customFetcher(url, {
    query: getGqlString(CREATE_BOOKING),
    variables: arg,
  });
};

type UseCreateBooking = {
  onError?: (error: any) => void;
  onSuccess?: (data: any, key: string) => void;
};

export const useCreateBooking = ({ onError, onSuccess }: UseCreateBooking) => {
  return useSWRMutation(config.APPS_SERVER, createBookingMutationFetcher, {
    ...swrConfig,
    onError,
    onSuccess,
  });
};
